import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var HighlightIconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n  border-radius: 50%;\n  background-color: ", "66;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  div {\n    padding: ", "px;\n    border-radius: 50%;\n    background-color: ", "66;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  svg {\n    font-size: ", "px;\n    fill: ", ";\n  }\n"], ["\n  padding: ", "px;\n  border-radius: 50%;\n  background-color: ", "66;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  div {\n    padding: ", "px;\n    border-radius: 50%;\n    background-color: ", "66;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  svg {\n    font-size: ", "px;\n    fill: ", ";\n  }\n"])), function (_a) {
    var size = _a.size;
    return (size || 24) / 3;
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color || "primary"].lightest;
}, function (_a) {
    var size = _a.size;
    return (size || 24) / 3;
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color || "primary"].lighter;
}, function (_a) {
    var size = _a.size;
    return size || 24;
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color || "primary"].default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map